import { CompanyData, CompanyModel } from 'models/CompanyModel';
import { ApiBase } from 'utils/api';
import { UserData } from 'models/UserModel';


export default class CompanyApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    all = (type: string) => this.base.axios
        .get('/api/companies', {params: {type}})
        .then(res => res.data);

    search = (s: string) => this.base.axios
        .get(`/api/companies/search`, {params: {s}})
        .then(res => res.data);

    create = (type: string, company: CompanyData, admin: UserData) => this.base.axios
        .post(`/api/companies`, {...company, admin, type});

    update = (company: CompanyModel) => this.base.axios
        .put(`/api/companies/${company.id}`, company);

    disable = (id: number) => this.base.axios
        .delete(`/api/companies/${id}`);

    setStamp = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);

        return this.base.axios.put(`/api/company/stamp`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    };

    delStamp = () => this.base.axios
        .delete('/api/company/stamp');

    setLogo = (file: File) => {
        const formData = new FormData();
        formData.append('file', file);

        return this.base.axios.put(`/api/company/logo`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    };

    delLogo = () => this.base.axios
        .delete('/api/company/logo');

    setVessels = (id: number, vessels: number[]) => this.base.axios
        .post(`/api/companies/${id}/vessels`, {vessels})
        .then(res => res.data);
}
